module.exports = __webpack_public_path__ + "img/public/siteImages/paypal.svg?08fb3b30";